import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { ClientAutofillData } from '../../models/userRegister.model';

export interface OtpState {
    hashCode: string;
    email: string;
    clientAutofillData: ClientAutofillData;
}

export function createInitialState(): OtpState {
    return {
        hashCode: null,
        email: null,
        clientAutofillData: null,
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'otp', resettable: true })
export class OtpStore extends Store<OtpState> {
    constructor() {
        super(createInitialState());
    }
}
